/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { FilterQuery } from 'common/types/filters';
import * as ApiService from './ApiService';

const baseUrl = 'propertySearches';

export function propertySearch(data: FilterQuery) {
    return ApiService.post(true, `${baseUrl}/search`, data);
}
